module.exports = {
  xs: 640,
  small: 768,
  medium: 1024,
  large: 1200,
};
